module.exports = __webpack_public_path__ + "static/DJS2-6ef15edfaa18181356216f91f0d146dd.png";